import React, { useCallback, useState } from 'react';

import ClockDriftWarning from './ClockDriftWarning';

import { clockDriftStore } from '../../utilities/authTokenStore';

const ClockDriftNotification = () => {
  const [driftSteps, setDriftSteps] = useState<number | null>(
    () => Number(clockDriftStore.getToken()) || null,
  );

  const dismiss = useCallback(() => {
    clockDriftStore.removeToken();
    setDriftSteps(null);
  }, [setDriftSteps]);

  return <ClockDriftWarning driftSteps={driftSteps} onDismiss={dismiss} />;
};

export default ClockDriftNotification;
